'use client';

import { type SanityDownloadablePdf } from '@metmuseum/types';
import styles from './visit-guide-card.module.scss';
import { PublicationCardImage } from 'components/publications/publication-card/image';
import DownloadButton from 'components/controls/links/download-button';
import { Link } from 'src/navigation';
import MarkdownParser from 'components/rich-text/markdown-parser';
import trackClickButton from 'lib/analytics/trackClickButton';

interface IProps {
	contentBlock?: string;
	pdf: Pick<SanityDownloadablePdf, 'title' | 'coverImage' | 'pdfFile'>;
}

const VisitGuideCard = ({ pdf, contentBlock }: IProps) => {
	const { title, coverImage, pdfFile } = pdf;
	const url = pdfFile.asset.url;

	const handleDownloadClick = () => {
		if (contentBlock) {
			trackClickButton({
				buttonClicked: 'pdf_download',
				contentBlock,
				contentName: title,
				contentType: 'promo',
			});
		}
	};

	return (
		<div className={styles.card}>
			{coverImage && (
				<PublicationCardImage
					coverImage={coverImage}
					link={url}
					onClick={handleDownloadClick}
				/>
			)}
			<div className={styles.body}>
				<h4 className={styles.heading}>
					<Link href={url}>
						<MarkdownParser>{title}</MarkdownParser>
					</Link>
				</h4>
			</div>

			<DownloadButton
				file={pdfFile.asset}
				target="_blank"
				rel="noopener noreferrer"
				onClick={handleDownloadClick}
			/>
		</div>
	);
};

export default VisitGuideCard;
